"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResultsCount = exports.FilterButtonText = exports.FilterButtonContainer = exports.FilterBadges = exports.CloseIcon = exports.Badge = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _index = _interopRequireDefault(require("../../../components/CTAList/index.styled"));
var _LexusTypography = require("../../../components/LexusTypography");
var _breakpoints = _interopRequireWildcard(require("../../../components/breakpoints"));
var _IconLibrary = require("../../../packages/IconLibrary");
const CloseIcon = exports.CloseIcon = (0, _styledComponents.default)(_IconLibrary.CloseHeavy)`
  margin: 0 0 0 4px;
  width: 10px;
  height: 10px;
`;
const FilterBadges = exports.FilterBadges = _styledComponents.default.div`
  display: flex;
  gap: 16px 10px;
  flex-wrap: nowrap;
  align-items: center;
  ${_index.default.CTAListWrapper} {
    display: flex;
    align-items: center;
  }
  ${(0, _breakpoints.breakpoint)("desktop", "up")} {
    flex-wrap: nowrap;
  }
`;
const Badge = exports.Badge = _styledComponents.default.button`
  border: 2px solid #a48b5b;
  padding: 7px 12px;
  text-transform: uppercase;
  flex-shrink: 0;
  ${(0, _LexusTypography.nobel)({
  sizing: "body12",
  weight: "regular"
})}
  background: none;
  align-items: baseline;
  cursor: pointer;
  display: flex;
`;
const FilterButtonContainer = exports.FilterButtonContainer = _styledComponents.default.div`
  position: relative;
  overflow: visible;
  margin: 0 10px 0 0;
  display: flex;
  align-items: center;
  ${(0, _breakpoints.default)("tablet", "up")} {
    margin-left: auto;
  }
  button {
    padding: 0;
    height: 40px;
    min-width: 100px;
    svg {
      width: 16px;
      height: 12px;
    }
    ${(0, _breakpoints.default)("tablet", "up")} {
      min-width: 140px;
    }
    ${(0, _breakpoints.default)("desktop", "up")} {
      &:hover svg {
        filter: brightness(0) saturate(100%) invert(100%) sepia(26%) saturate(148%) hue-rotate(250deg) brightness(121%) contrast(100%);
      }
    }
  }
`;
const FilterButtonText = exports.FilterButtonText = _styledComponents.default.span`
  margin-right: 18px;
`;
const ResultsCount = exports.ResultsCount = _styledComponents.default.div`
  position: absolute;
  padding: 1px;
  top: -10px;
  right: -10px;
  ${(0, _LexusTypography.nobel)({
  sizing: "link11",
  weight: "regular"
})}
  color: #fff;
  background-color: #000;
  border-radius: var(--radius);
  min-width: 17px;
  min-height: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
`;